<template>
  <div>
    <el-select
      :placeholder="$t('Seçin')"
      filterable
      :value="selected"
      @input="handleInput"
      style="width: 100%"
    >
      <el-option
        v-for="item in data"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { GetMedDamageTypes } from "../../services/cls";
export default {
  props: {
    value: [Number, String],
  },
  data() {
    return {
      data: [],
      selected: this.value,
    };
  },
  methods: {
    handleInput(e) {
      this.$emit("input", e);
      this.selected = e;
    },

    getData() {
      GetMedDamageTypes().then((response) => {
        if (response.data.data) {
          this.data = response.data.data;
        } else {
          this.$message({
            type: "error",
            message: "Med Damage Types: No data found!",
          });
        }
      });
    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    value() {
      this.selected = this.value;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>